import localforage from 'localforage';
import { observable, action, runInAction } from 'mobx';

const moStaff = observable({
  staffTabActive: '元均营业收入',
  staffActiveShow: 'chart',
  staffList: <any>{},
});


// 修改tab
const changeTab = action(async (val: string) => {
  runInAction(() => {
    moStaff.staffTabActive = val;
  });
  const humanData: any = await localforage.getItem('humans') || {};
  humanData.stafftab = val;
  localforage.setItem('humans', humanData);
});

// 修改默认tab
const changeStaffTab = action(async (val: string) => {
  runInAction(() => {
    moStaff.staffTabActive = val;
  });
});


// 展示表格还是图表

const changeStaffShow = action(async (val: string) => {
  runInAction(() => {
    moStaff.staffActiveShow = val;
  });
  const humanData: any = await localforage.getItem('humans') || {};
  humanData.stafftable = val;
  localforage.setItem('humans', humanData);
});


// 展示默认表格还是图表

const changeStaShow = action(async (val: string) => {
  runInAction(() => {
    moStaff.staffActiveShow = val;
  });
});

// 获取默认数据

const getStaffSize = action((val: string) => {
  runInAction(() => {
    moStaff.staffList = val;
  });
});

export default moStaff;
export { changeTab, changeStaffShow, getStaffSize, changeStaffTab, changeStaShow };
